// extracted by mini-css-extract-plugin
module.exports = {"exploreDealBlock":"Deals-module__exploreDealBlock___2-Opo explore-deal-block"};